import React, { useState } from 'react';
import styles from './Footer.module.css'


const Footer: React.FC = () => {

  return (
    <footer className={`footer text-light ${styles['footer']}`} >
      <div className="container">

        <hr className="border-secondary bottom-line" />
        {/* Footer Bottom */}
        <div className="bottom-block" style={{display:'unset'}}>
          <div className='text-center'>© {new Date().getFullYear()} BreatheEV. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
